export const RewardsHubSegmentsContentPath: string = 'Promo/PromoHub/ClientContent/DashboardContent';
export const DashboardContentPath: string = 'Rewards-Hub/Content/Dashboard/UserBanner';

export class DashboardContent {
    messages: RewardsHubSegments;
}

export class RewardsHubSegments {
    promoHub: string;
    rewardsHub: string;
}
